module.exports = __webpack_public_path__ + "img/1505353660.6ffcbdef.jpg";